import { FORMIK_EMPTY_VALUE } from '../../../../constants/validation'

export const CREATE_PASSWORD_FORM_FIELD_NAME_PASSWORD = 'password'

export const CREATE_PASSWORD_FORM_FIELD_NAME_REPEAT_PASSWORD = 'repeatPassword'

export const CREATE_PASSWORD_FORM_FIELD_NAME_ACCEPT_RULES = 'acceptRules'

export const CREATE_PASSWORD_FORM_INITIAL_VALUES = {
  [CREATE_PASSWORD_FORM_FIELD_NAME_ACCEPT_RULES]: false,
  [CREATE_PASSWORD_FORM_FIELD_NAME_PASSWORD]: FORMIK_EMPTY_VALUE,
  [CREATE_PASSWORD_FORM_FIELD_NAME_REPEAT_PASSWORD]: FORMIK_EMPTY_VALUE,
}

export const CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_EQUAL =
  'password-is-not-equal'

export const CREATE_PASSWORD_FORM_VALIDATION_ERROR_PASSWORD_IS_NOT_MATCH_REQUIREMENTS =
  'password-is-not-match-requirements'

export const CREATE_PASSWORD_FORM_VALIDATION_ERROR_RULES_ARE_NOT_ACCEPTED =
  'rules-are-not-accepted'

export const CREATE_PASSWORD_FORM_PASSWORD_MAX_LENGTH = 30

export const CREATE_PASSWORD_FORM_FIELD_HEIGHT = 48
